module.exports = __webpack_public_path__ + "static/section-story-344174dc1602dff3c6e1dcee93c335dd.jpg";